module.exports = __webpack_public_path__ + "static/media/expert3.21c5ef5e.png";